module.exports = __webpack_public_path__ + "img/func-keypal-1.cd43262b.png";